import { requiredParam } from "./utils";

/**
 * Inserts a script tag
 * @param  {string} url      script URL
 * @param  {function} onload callback that is run after script is loaded
 */
export function injectScript(
  url,
  onload,
  appendToBody = false,
  scriptAttributes = null,
  async = true
) {
  const scriptEl = document.createElement("script");
  scriptEl.src = url;
  scriptEl.type = "text/javascript";
  scriptEl.async = async;
  scriptEl.onload = onload;

  if (scriptAttributes) {
    for (var key in scriptAttributes) {
      // check if the property/key is defined in the object itself, not in parent
      if (scriptAttributes.hasOwnProperty(key)) {
        scriptEl.setAttribute(key, scriptAttributes[key]);
      }
    }
  }

  if (appendToBody) {
    document.body.appendChild(scriptEl);
  } else {
    const el = document.getElementsByTagName("script")[0];
    el.parentNode.insertBefore(scriptEl, el);
  }
}

/**
 * Injects link to stylesheet file
 * @param  {string} url stylesheet file URL
 */
export function injectStyles(url) {
  const linkEl = document.createElement("link");
  linkEl.rel = "stylesheet";
  linkEl.type = "text/css";
  linkEl.href = url;

  const el = document.querySelectorAll("link[rel=stylesheet]")[0];
  if (el) {
    el.parentNode.insertBefore(linkEl, el);
  } else {
    document.head.appendChild(linkEl);
  }
}

/**
 * Inserts Google Analytics script tag
 * @param  {string} gaTag client specific Google Analytics tag (UA-xxxxxxxx-xx)
 */
export function insertGAScriptTag(
  gaTag = requiredParam("GA Tag"),
  isEnabled = true
) {
  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i["GoogleAnalyticsObject"] = r;
    (i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    "script",
    "//www.google-analytics.com/analytics.js",
    "ga"
  );

  if (isEnabled) {
    window[`ga-disable-${gaTag}`] = false;
  } else {
    window[`ga-disable-${gaTag}`] = true;
  }

  ga("create", gaTag, "auto");
  /* eslint-enable */
}

/**
 * Inserts Google Tag Manager script
 * @param  {string} gaTag client specific Google Analytics tag (GTM-xxxxxxxx)
 */
export function insertGTMScriptTag(gtmTag = requiredParam("GTM Tag")) {
  /* eslint-disable */
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", gtmTag);
}

/**
 * Inserts a noscript tag with an iframe in it
 * @param  {string} url      iframe URL
 */
export function injectNoScript(url) {
  const noScriptEl = document.createElement("noscript");
  var iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  iframe.src = url;
  iframe.width = 0;
  iframe.height = 0;
  noScriptEl.appendChild(iframe);
  //element.prepend does not work on IE

  var bodyFirstElement = document.body.firstElementChild;
  document.body.insertBefore(noScriptEl, bodyFirstElement);
  //document.body.prepend(noScriptEl);
}

export function insertCxenseScriptTag() {
  /* eslint-disable */
  (function (d, s, e, t) {
    e = d.createElement(s);
    e.type = "text/java" + s;
    e.async = "async";
    e.src =
      "http" +
      ("https:" === location.protocol ? "s://s" : "://") +
      "cdn.cxense.com/cx.js";
    t = d.getElementsByTagName(s)[0];
    t.parentNode.insertBefore(e, t);
  })(document, "script");
  /* eslint-enable */
}

let browser = null;

export function getBrowser() {
  if (browser === null) {
    const ua = navigator.userAgent;
    let tem = null;
    let match =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];

    if (/trident/i.test(match[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      browser = {
        name: "IE",
        version: tem[1] || "",
      };
    }
    if (match[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) {
        browser = {
          name: tem[1].replace("OPR", "Opera"),
          version: tem[2],
        };
      }
    }
    match = match[2]
      ? [match[1], match[2]]
      : [navigator.appName, navigator.appVersion, "-?"];
    tem = ua.match(/version\/(\d+)/i);
    if (tem != null) match.splice(1, 1, tem[1]);

    browser = {
      name: match[0],
      version: match[1],
    };
  }

  return browser;
}

export function injectDidomiScript(didomiKey = requiredParam("Didomi Key")) {
  window.gdprAppliesGlobally = true;
  (function () {
    function a(e) {
      if (!window.frames[e]) {
        if (document.body && document.body.firstChild) {
          var t = document.body;
          var n = document.createElement("iframe");
          n.style.display = "none";
          n.name = e;
          n.title = e;
          t.insertBefore(n, t.firstChild);
        } else {
          setTimeout(function () {
            a(e);
          }, 5);
        }
      }
    }
    function e(n, r, o, c, s) {
      function e(e, t, n, a) {
        if (typeof n !== "function") {
          return;
        }
        if (!window[r]) {
          window[r] = [];
        }
        var i = false;
        if (s) {
          i = s(e, t, n);
        }
        if (!i) {
          window[r].push({ command: e, parameter: t, callback: n, version: a });
        }
      }
      e.stub = true;
      function t(a) {
        if (!window[n] || window[n].stub !== true) {
          return;
        }
        if (!a.data) {
          return;
        }
        var i = typeof a.data === "string";
        var e;
        try {
          e = i ? JSON.parse(a.data) : a.data;
        } catch (t) {
          return;
        }
        if (e[o]) {
          var r = e[o];
          window[n](
            r.command,
            r.parameter,
            function (e, t) {
              var n = {};
              n[c] = { returnValue: e, success: t, callId: r.callId };
              a.source.postMessage(i ? JSON.stringify(n) : n, "*");
            },
            r.version
          );
        }
      }
      if (typeof window[n] !== "function") {
        window[n] = e;
        if (window.addEventListener) {
          window.addEventListener("message", t, false);
        } else {
          window.attachEvent("onmessage", t);
        }
      }
    }
    e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn");
    a("__tcfapiLocator");
    (function (e) {
      var t = document.createElement("script");
      t.id = "spcloader";
      t.type = "text/javascript";
      t.async = true;
      t.src =
        "https://sdk.privacy-center.org/" +
        e +
        "/loader.js?target=" +
        document.location.hostname;
      t.charset = "utf-8";
      var n = document.getElementsByTagName("script")[0];
      n.parentNode.insertBefore(t, n);
    })(didomiKey);
  })();
}

/**
 * @description Inject the Tealium scripts at their relevant positions
 * @param uTagUrl {string}
 * @param uTagSyncUrl {string}
 * @param cpmtUrl {string}
 */
export function injectTealiumScripts({ uTagUrl, uTagSyncUrl, cpmtUrl }) {
  if (!uTagUrl || !uTagSyncUrl || !cpmtUrl) {
    console.error(
      "Could not inject the Tealium scripts because one or more of the required URLs are undefined.",
      {
        uTagUrl,
        uTagSyncUrl,
        cpmtUrl,
      }
    );
    return;
  }

  const uTagScript = document.createElement("script");
  uTagScript.src = uTagUrl;
  uTagScript.crossOrigin = "anonymous";

  const uTagDataVariable = document.createElement("script");
  uTagDataVariable.type = "text/javascript";
  uTagDataVariable.text = `var utag_data = {};`;

  const uTagSyncScript = document.createElement("script");
  uTagSyncScript.src = uTagSyncUrl;
  uTagSyncScript.crossOrigin = "anonymous";

  const cpmtScript = document.createElement("script");
  cpmtScript.src = cpmtUrl;
  document.body.prepend(cpmtScript);

  document.head.appendChild(uTagSyncScript);
  document.body.prepend(uTagScript);
  document.body.prepend(uTagDataVariable);
}



// WEBPACK FOOTER //
// ./src/common/utilities/DOMUtils.js